export const NOTIFICATION_ERROR_KEY = {
    unsupported: 'unsupported',
    'not-installed': 'needsInstall',
    'permission-denied': 'denied',
    // 还没申请过还走到失败分支，说明是流程出了问题，不是用户的问题
    'permission-default': 'otherError',
    'requires-user-gesture': 'gestureError',
    'insecure-context': 'unsupported',
    'no-service-worker': 'otherError',
    'platform-restriction': 'unsupported',
    failed: 'otherError',
};
/** 拿到该显示的那句话。永远有值——这是这张表存在的全部意义。 */
export function notificationErrorText(strings, reason) {
    return strings.notification[NOTIFICATION_ERROR_KEY[reason]];
}
//# sourceMappingURL=permission-reason.js.map